<mapfre-card 
    [singleCard]="false"
    [additionalClasses]="'policy-details'"> 
<div class="single-card-column policy-card">
  <div class="row text-center">
    <div class="col">
      <div class="header-icon full-icon" *ngIf="!isAcmic">
        <svg-policy-error-svg></svg-policy-error-svg>
      </div>
      <h1 class="title-copy">{{ 'Policy linked to another account' | translate }}</h1>
    <ng-container *ngIf="policyId.length!==6; else as400">
    <div class="sub-title-copy lowercase">
      {{ 'Policy is linked to the following email' | translate }}
    </div>
    <div class="sub-title-copy lowercase">
      {{ 'Do you recognize it?' | translate }}
    </div>
    <div class="sub-title-copy margin-vertical mv16">
      <strong>{{ email }}</strong>
    </div>
    <hr class="margin-vertical mv16"/>
  </ng-container>
  <ng-template #as400>
      <div class="sub-title-copy">
    {{ 'POLICY_LINKED_TO_ANOTHER_EMAIL_DISCRIPTION' | translate }}
      </div>
  </ng-template>
  </div>
  </div>
<div>
<div class="row margin-bottom mb16">
  <div class="col">
      <div class="row  text-center">
        <div class="col">
          <div class="margin-vertical mt15">
            <mapfre-button additionalClasses="ghost primary large full" [routerLink]="['/my-insurance','link-policy']"
              [translateValue]=" 'REVIEW_DETAILS_LINK' | translate ">
              {{ 'REVIEW_DETAILS_LINK' | translate }}
            </mapfre-button>
          </div>
        </div>
    </div>
  </div>
</div>
<hr>
<ng-container *ngIf="policyId.length===6 && !isAcmic; else gwPolicy">
<div class="row margin-bottom text-center mb16">
  <div class="sub-title-copy lowercase">
    {{ 'POLICY_LINKED_TO_ANOTHER_EMAIL_PERSONAL_ASSISTANCE' | translate }}
    <a href="tel:18009228276">1-800-922-8276</a> {{ 'POLICY_LINKED_TO_ANOTHER_FOR_OR' | translate }}
    <a href="mailto:Generalcomments@mapfreusa.com">{{ 'POLICY_LINKED_TO_ANOTHER_EMAIL_SEND_US_EMAIL' | translate }}</a>
  </div>
</div>
</ng-container>
<ng-template #gwPolicy>
<div *ngIf="!isAcmic; else isAcmic" class="row margin-bottom text-center mb16">
  <div class="sub-title-copy lowercase">
    If you dont recognize that email and the data entered is correct, please don't hesitate to contact our Customer Service Department by calling
    <a href="tel:18556273737">1-855-627-3737</a> {{ 'POLICY_LINKED_TO_ANOTHER_FOR_OR' | translate }}
    <a href="mailto:Generalcomments@mapfreusa.com">{{ 'POLICY_LINKED_TO_ANOTHER_EMAIL_SEND_US_EMAIL' | translate }}</a>
  </div>
</div>
</ng-template>
<ng-template #isAcmic>
  <div class="sub-title-copy lowercase text-center">If you don't recognize that email and the data<br>
    entered is correct, please don't hesitate to<br>
    contact our Customer Service Department.<br>
    <a href="tel:18442954500"><b><u>1-844-295-4500</u></b></a>
  </div>
  </ng-template>
</div>
</div>
</mapfre-card>